import { Language } from '@yleisradio/areena-types';
import { areenaApi } from '../client/environment';
import { getCommonUiApiParameters } from './areena-api/fetchers';

export function getUrlWithAuthentication(
  apiUrl: string,
  appId: string,
  appKey: string
): string {
  try {
    const url = new URL(apiUrl);
    url.searchParams.set('app_id', appId);
    url.searchParams.set('app_key', appKey);
    return url.href;
  } catch (e) {
    console.error(e, 'Failed adding API keys to URL');
    return apiUrl;
  }
}

export function getAreenaApiUrlByViewPath(
  viewPath: string,
  language: Language
): string {
  return `${areenaApi.url}/v1/ui/views${viewPath}.json?${getCommonUiApiParameters(language)}`;
}
